// Wire-protocol header / query param names — the strings the BACKEND
// reads from request headers, WS URL params, and writes into response
// headers. Renaming here = lockstep change with backend.
//
// Distinct namespace from `STORAGE_KEYS` (browser localStorage). They
// happen to share the `x-sr-*` prefix today, but a rename on either side
// shouldn't drag the other. Keep them separate even when values match.
//
// Backend serves host and sub-app traffic off one contract; if these strings
// drift, the auth signature mismatches and every request 401s.
export const WIRE_HEADERS = {
  ubid: 'x-sr-ubid',
  token: 'x-sr-token',
  aid: 'x-sr-aid',
  nonce: 'x-sr-nonce',
  timestamp: 'x-sr-timestamp',
  signature: 'x-sr-signature',
} as const;
